var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher"},[_c('FontIcon',{attrs:{"name":"ui_language"}}),_c('SelectInput',{class:`language-select language-${_vm.locale}`,attrs:{"id":"input--language-switcher","label":"","options":_vm.options,"value":_vm.locale},on:{"update:value":function($event){return _vm.$emit('update:locale', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }